import { processParamsToHeaders } from "@/functions/helpers/serviceHelper";
import authHeader from "./auth-header";
import axiosInstance from "./instance";

class ShipsService {
  getMaintainersV2(params) {
    return axiosInstance.get("/v2/maintainers", {
      params: params,
      headers: authHeader(),
    });
  }

  getSLAMaintainersV2() {
    return axiosInstance.get("/v2/sla_maintainers", {
      headers: authHeader(),
    });
  }

  getOwners(maintainer) {
    return axiosInstance.get("/owners", {
      params: { maintainer: maintainer.toLowerCase() },
      headers: authHeader(),
    });
  }

  getOwnersV2(params) {
    return axiosInstance.get("/v2/owners", {
      params: params,
      headers: authHeader(),
    });
  }

  getOwnerShips(maintainer, ownerId) {
    return axiosInstance.get("/ships", {
      params: {
        maintainer,
        owner_id: ownerId,
      },
      headers: authHeader(),
    });
  }

  getOwnerShipsV2(params) {
    return axiosInstance.get("/v2/ships", {
      params: params,
      headers: authHeader(),
    });
  }

  addSla(params) {
    return axiosInstance.put("/add_sla", params, {
      headers: authHeader(),
    });
  }

  getShipById(params) {
    return axiosInstance.get("/ships", {
      params: {
        maintainer: params.maintainer,
        id: params.shipId,
      },
      headers: authHeader(),
    });
  }

  getShipByIdV2(params) {
    return axiosInstance.get("/v2/ships", {
      params: params,
      headers: authHeader(),
    });
  }

  getShipKpi(params) {
    const data = {
      date_from: params.dateFrom,
      date_to: params.dateTo,
      maintainer: params.maintainer,
      owner: params.ownerId,
      ship_imo: params.shipImo,
      ship_id: params.shipId,
    };
    const { headers } = processParamsToHeaders(params);
    return axiosInstance.post("/get_ship_kpi", data, {
      headers: { ...headers, ...authHeader() },
    });
  }

  getShipsV2(params) {
    return axiosInstance.get("/v2/ships", {
      params: params,
      headers: authHeader(),
    });
  }
  getShipServiceDetails(params) {
    return axiosInstance.get("/service/details", {
      params: params,
      headers: authHeader(),
    });
  }
  getCasesDefinitions(params) {
    return axiosInstance.get("/service/cases_definitions", {
      params: params,
      headers: authHeader(),
    });
  }
  saveCase(params) {
    return axiosInstance.post("/service/case", params, {
      headers: authHeader(),
    });
  }

  createCase(params) {
    return axiosInstance.put("/service/case", params, {
      headers: authHeader(),
    });
  }
  getCases(params) {
    return axiosInstance.get("/service/case", {
      params: params,
      headers: authHeader(),
    });
  }
  createCaseAttachment(params) {
    return axiosInstance.put("/service/case_attachment", params, {
      headers: authHeader(),
    });
  }
  updateOrCreateSystem(params) {
    return axiosInstance.put("/service/system", params, {
      headers: authHeader(),
    });
  }
  getExclusions(params) {
    return axiosInstance.get("/v2/watchdog_exclusions", {
      params: params,
      headers: authHeader(),
    });
  }
  getSLAList(params) {
    return axiosInstance.get("/sla_list", {
      params: params,
      headers: authHeader(),
    });
  }
  updateSLA(license) {
    return axiosInstance.post("/update_sla", license, {
      headers: authHeader(),
    });
  }
  createSLA(license) {
    return axiosInstance.put("/add_sla", license, {
      headers: authHeader(),
    });
  }
  getSystemList(params) {
    return axiosInstance.get("/service/system_list", {
      params: params,
      headers: authHeader(),
    });
  }

  getSystemListAdvanced(params) {
    return axiosInstance.post("/service/system_list", params, {
      headers: authHeader(),
    });
  }

  getSystemDefinitions() {
    return axiosInstance.get("/service/system_definitions", {
      headers: authHeader(),
    });
  }
  getHardwareDefinitions() {
    return axiosInstance.get("/service/hardware_definitions", {
      headers: authHeader(),
    });
  }
  getSoftwareDefinitions() {
    return axiosInstance.get("/service/software_definitions", {
      headers: authHeader(),
    });
  }
  updateOrCreateDefinition(definition) {
    return axiosInstance.put("/service/definition", definition, {
      headers: authHeader(),
    });
  }
  getSystemsForShip(params) {
    return axiosInstance.get("/service/systems_for_ship", {
      params: params,
      headers: authHeader(),
    });
  }
  getMaintainerDispName(params) {
    return axiosInstance.get("/get_maintainer_disp_name", {
      params: params,
      headers: authHeader(),
    });
  }
  getSoftwareList(params) {
    return axiosInstance.get("/service/software_list", {
      params: params,
      headers: authHeader(),
    });
  }
  getHardwareList(params) {
    return axiosInstance.get("/service/hardware_list", {
      params: params,
      headers: authHeader(),
    });
  }
  updateSoftware(params) {
    return axiosInstance.post("/service/software", params, {
      headers: authHeader(),
    });
  }
  updateHardware(params) {
    return axiosInstance.post("/service/hardware", params, {
      headers: authHeader(),
    });
  }
  getLinksList(params) {
    return axiosInstance.get("/service/links_list", {
      params: params,
      headers: authHeader(),
    });
  }
  updateOrCreateLink(params) {
    return axiosInstance.put("/service/link", params, {
      headers: authHeader(),
    });
  }
  deactivateShip(params) {
    return axiosInstance.post("/deactivate_ship", params, {
      headers: authHeader(),
    });
  }
  updateNotes(params) {
    return axiosInstance.post("/update_ship_notes", params, {
      headers: authHeader(),
    });
  }
  updateShip(params) {
    return axiosInstance.post("/update_ship", params, {
      headers: authHeader(),
    });
  }
}
export default new ShipsService();
